import React from 'react';

const Notfound = ({ setIsLogin }) => {
  return <div>Pagina no encontrada.</div>;
};

export default Notfound;
